import React from "react";
import PropTypes from "prop-types";

import { SubTitle } from "../SubTitle";
import ModalTitle from "../../../../../../layout/AppLayout/ModalDialog/ModalTitle";

export const FundingFormTitle = ({
  isFundingPaidConfirmation,
  closeModalDialog,
}) => {
  if (isFundingPaidConfirmation) return null;

  return (
    <ModalTitle
      title="Create Fund Request"
      extraTitle={<SubTitle />}
      isShowCloseIcon
      closeModalDialog={closeModalDialog}
      width="100%"
    />
  );
};
FundingFormTitle.propTypes = {
  isFundingPaidConfirmation: PropTypes.bool,
  closeModalDialog: PropTypes.func,
};
